/**
* DialogOptionHelper.js
* 
* Created on 27-nov-2013, 11:30:51
*
* @author Ivo Swartjes for Ranj
**/

import ContentTypes from "/lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class DialogOptionHelper {

    static isBackOption(option) {
        // A conversation topic type with label "[END]"
        var metaData = option.getMetaData();
        if (isNull(metaData))
            return false;
        var label = metaData.label;

        if (label === "[BACK]") {
            return true;
        } else {
            return false;
        }
    }
    static isContinueOption(option) {
        var metaData = option.getMetaData();
        if (isNull(metaData))
            return false;
        var label = metaData.label;

        if (label === "[CONTINUE]") {
            return true;
        } else {
            return false;
        }
    }
    static isEndOption(option) {
        // A conversation topic type with label "[END]"
        var metaData = option.getMetaData();
        if (isNull(metaData))
            return false;
        var label = metaData.label;

        if (label === "[END]") {
            return true;
        } else {
            return false;
        }
    }
    static isConversationTopicOption(option) {
        var dialogContentPackage = null;
        if (!isNull(option.getData())) {
            dialogContentPackage = option.getData().getData();
        }
        if (!isNull(dialogContentPackage)) {
            var content = dialogContentPackage.content;
            if (content.getType() === ContentTypes.TYPE_CONVERSATION_TOPIC) {
                return true;
            }
        }

        return false;
    }
}







